import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { requestProductDetails } from 'src/redux/product/thunks';
import {
  NextOrPreviousPayload,
  OpenModalPayload,
  ProductImagesState,
  SetCurrentImagePayload,
} from '../types';

export const initialState: Readonly<ProductImagesState> = {
  navigatedBy: null,
  currentImage: 0,
  lastImage: 0,
  isModalOpen: false,
};

export const { actions, reducer } = createSlice({
  name: 'productImagesCarousel',
  initialState,
  reducers: {
    nextImage: (state, _action: PayloadAction<NextOrPreviousPayload>) => {
      state.currentImage = state.currentImage === state.lastImage ? 0 : state.currentImage + 1;
      state.navigatedBy = 'click';
    },
    prevImage: (state, _action: PayloadAction<NextOrPreviousPayload>) => {
      state.currentImage = state.currentImage === 0 ? state.lastImage : state.currentImage - 1;
      state.navigatedBy = 'click';
    },
    setCurrentImage: (state, action: PayloadAction<SetCurrentImagePayload>) => {
      state.currentImage = action.payload.imageIndex;
      state.navigatedBy = action.payload.navigationType;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    openModal: (state, _action: PayloadAction<OpenModalPayload>) => {
      state.isModalOpen = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(requestProductDetails.fulfilled, (state, { payload }) => {
      const {
        product: { images },
      } = payload;

      state.lastImage = images.length - 1;
    });
  },
});
